import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";

const faqs = [
    {
        question: "OSGB ile çalışmak yasal zorunluluk mu?",
        answer: "6331 sayılı İş Sağlığı ve Güvenliği Kanunu gereğince tüm işverenler; işyerinde işyeri hekimi, iş güvenliği uzmanı ve diğer sağlık personeli bulundurmak veya bu hizmetleri OSGB'den almakla yükümlüdür. Yükümlülüğü yerine getirmeyen işverenlere idari para cezası uygulanmaktadır.",
    },
    {
        question: "Hangi tehlike sınıflarında hizmet veriyorsunuz?",
        answer: "Az tehlikeli, tehlikeli ve çok tehlikeli olmak üzere tüm tehlike sınıflarında hizmet veriyoruz. Uzman iş güvenliği uzmanlarımız A, B ve C sertifika düzeylerinin tamamına sahiptir.",
    },
    {
        question: "Sözleşme süresi ne kadardır?",
        answer: "Sözleşmelerimiz genellikle 1 yıllık olarak düzenlenmektedir. Ancak işletmenizin ihtiyaçlarına göre daha uzun süreli anlaşmalar da yapılabilmektedir.",
    },
    {
        question: "İşyerimize ne sıklıkla ziyaret yapılır?",
        answer: "Ziyaret sıklığı, işletmenizin tehlike sınıfı ve çalışan sayısına göre mevzuat tarafından belirlenmektedir. Çok tehlikeli sınıftaki işyerleri için aylık ziyaretler gerçekleştirilirken az tehlikeli sınıf için bu süre daha uzun olabilmektedir.",
    },
    {
        question: "İşe giriş muayeneleri ne zaman yapılmalıdır?",
        answer: "İşe giriş muayeneleri çalışanın işe başlamadan önce yapılması zorunludur. Periyodik muayeneler ise tehlike sınıfına göre yılda bir veya iki yılda bir tekrarlanmaktadır.",
    },
];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <section className="section section-lg">
            <Container>
                <Row className="justify-content-center mb-5">
                    <Col lg="8" className="text-center">
                        <h1 className="text-white">Sık Sorulan Sorular</h1>
                        <p className="text-white">OSGB hizmetleri hakkında merak edilen konular</p>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg="8">
                        {faqs.map((faq, i) => (
                            <div
                                key={i}
                                style={{
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    borderRadius: 12,
                                    marginBottom: 12,
                                    overflow: "hidden",
                                }}
                            >
                                <button
                                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                    style={{
                                        width: "100%",
                                        background: "none",
                                        border: "none",
                                        padding: "1rem 1.5rem",
                                        textAlign: "left",
                                        color: "white",
                                        fontWeight: 500,
                                        fontSize: "1rem",
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <span>{faq.question}</span>
                                    <i
                                        className={`tim-icons ${openIndex === i ? "icon-minimal-up" : "icon-minimal-down"}`}
                                        style={{ fontSize: 12 }}
                                    />
                                </button>
                                {openIndex === i && (
                                    <div style={{ padding: "0 1.5rem 1rem", color: "rgba(255,255,255,0.75)", fontSize: "0.9rem", lineHeight: 1.7 }}>
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
